import type { TypographyTheme } from '@sds-system/types';

export const typography: TypographyTheme = {
  title: {
    regular: {
      fontSize: '2.5rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
    medium: {
      fontSize: '2.5rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
    bold: {
      fontSize: '2.5rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
  },
  title2: {
    regular: {
      fontSize: '2rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
    medium: {
      fontSize: '2rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
    bold: {
      fontSize: '2rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
  },
  title3: {
    regular: {
      fontSize: '1.75rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
    medium: {
      fontSize: '1.75rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
    bold: {
      fontSize: '1.75rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
  },
  header: {
    regular: {
      fontSize: '1.5rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
    medium: {
      fontSize: '1.5rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
    bold: {
      fontSize: '1.5rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
  },
  header2: {
    regular: {
      fontSize: '1.25rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
    medium: {
      fontSize: '1.25rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
    bold: {
      fontSize: '1.25rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
  },
  header3: {
    regular: {
      fontSize: '1.125rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    medium: {
      fontSize: '1.125rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    bold: {
      fontSize: '1.125rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
  },
  body: {
    regular: {
      fontSize: '1rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    medium: {
      fontSize: '1rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    bold: {
      fontSize: '1rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
  },
  body2: {
    regular: {
      fontSize: '0.875rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
    medium: {
      fontSize: '0.875rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
    bold: {
      fontSize: '0.875rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
  },
  caption: {
    regular: {
      fontSize: '0.75rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
    medium: {
      fontSize: '0.75rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
    bold: {
      fontSize: '0.75rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
  },
  caption2: {
    regular: {
      fontSize: '0.625rem',
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
    medium: {
      fontSize: '0.625rem',
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
    bold: {
      fontSize: '0.625rem',
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
  },
};
